'use strict';

module.exports = '3.24.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = ./node_modules/algoliasearch/src/version.js
// module chunks = 0 1